export default __webpack_public_path__ + "static/media/img_logo_all.31df7766.png";